module.exports = function appearsExpires(appearsAttribute, expiresAttribute) {
    var milbMoment = window.milbMoment;
    var now = milbMoment._moment();
    var $dateSensitiveItems = document.querySelectorAll('[' + appearsAttribute + '], [' + expiresAttribute + ']');

    for (var i = 0; i < $dateSensitiveItems.length; i++) {

        var appears = milbMoment._moment($dateSensitiveItems[i].getAttribute(appearsAttribute));
        var expires = milbMoment._moment($dateSensitiveItems[i].getAttribute(expiresAttribute));

        // current date is after appear date - remove attribute setting display:none
        if (appears && now.isAfter(appears)) {
            $dateSensitiveItems[i].removeAttribute(appearsAttribute);
        }

        // current date is before expiration date - remove attribute setting display:none
        if (expires && now.isBefore(expires)) {
            $dateSensitiveItems[i].removeAttribute(expiresAttribute);
        }

    }
};
